import type { ConfigurationOperation } from '@festina/configuration-general-types/configuration'

import { useNavigationParams } from '../system/useNavigationParams'
import { getTransferableVersionsInBlock } from '../uiModels/transfer/getTransferableVersionsInBlock'
import type { IndexedOperations } from '../uiModels/types'
import type { ConfigurationItemsByBlock } from '../workspace/operationsContext'

/**
 * The versions of the configuration item that can be transferred off the block
 * currently in view.
 */
export const useTransferableVersionsInBlock = <
  T extends ConfigurationOperation,
>({
  operationsByBlock,
  itemId,
}: {
  operationsByBlock: ConfigurationItemsByBlock<IndexedOperations<T>>
  itemId: string
}) => {
  const { block } = useNavigationParams()

  return getTransferableVersionsInBlock({ operationsByBlock, block, itemId })
}
